export default "__VITE_ASSET__jIcSAi8V__"